import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, Loading, EmptyState } from "../../components/VB";

export default function PoinSaya() {
  const [items, setItems] = useState([]);
  const [kats, setKats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [p, k] = await Promise.all([api.get("/poin"), api.get("/poin-kategori")]);
        setItems(p.data); setKats(k.data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  const katName = (id) => kats.find((k) => k.id === id)?.nama || "-";
  const total = items.reduce((a, b) => a + (b.nilai || 0), 0);
  const rata = items.length ? (total / items.length).toFixed(2) : 0;

  return (
    <Window title="Poin Kinerja Saya">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 10, marginBottom: 12 }}>
        <div className="vb-statcard"><div className="vb-statcard-label">Total Poin</div><div className="vb-statcard-value">{total}</div></div>
        <div className="vb-statcard"><div className="vb-statcard-label">Rata-Rata</div><div className="vb-statcard-value">{rata}</div></div>
        <div className="vb-statcard"><div className="vb-statcard-label">Jumlah Entry</div><div className="vb-statcard-value">{items.length}</div></div>
      </div>
      {loading ? <Loading /> : items.length === 0 ? <EmptyState message="Belum ada poin" /> : (
        <table className="vb-table">
          <thead><tr><th>Tanggal</th><th>Kategori</th><th>Nilai</th><th>Catatan</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}><td>{it.tanggal}</td><td>{katName(it.kategori_id)}</td><td>{it.nilai}</td><td>{it.catatan || "-"}</td></tr>
            ))}
          </tbody>
        </table>
      )}
    </Window>
  );
}
